// material-ui
import { DataGrid } from '../../../components/grid/DataGrid';

// project import
import MainLayout from '../../../layout/MainLayout';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import MainCard from '../../../components/MainCard';
import { AppstoreAddOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid-pro';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { actions as routeActions, types as routes } from 'reducers/rotas.actions';

import * as actions from 'reducers/credenciais.reducer';
import useTheme from '@mui/system/useTheme';
import { toast } from 'react-toastify';

const CredenciaisPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { data: credenciais, loading } = useSelector((state) => state.credenciais.list);
  const { banks: banksDomain, status: statusDomain } = useSelector((state) => state.credenciais.domain);

  const rows = credenciais;

  const columns = [
    {
      field: 'tipo',
      headerName: 'Banco',
      valueFormatter: (value) => {
        return value ? banksDomain.find((b) => b.id === value)?.name ?? `??? (${value})` : '';
      }
    },
    {
      field: 'descricao',
      headerName: 'Descrição',
      flex: 1
    },
    {
      field: 'situacao',
      headerName: 'Situação',
      valueFormatter: (value) => {
        return value ? statusDomain.find((b) => b.id === value)?.name ?? `??? (${value})` : '';
      }
    },
    {
      field: 'default',
      headerName: 'Padrão',
      valueFormatter: (value) => {
        return value ? 'Sim' : 'Não';
      }
    }
  ];

  const [open, setOpen] = useState(false);

  const handleClickOpen = (row) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNewCredential = () => {
    dispatch(
      routeActions.redirectTo(routes.CREDENCIAL, {
        idCredencial: 'novo'
      })
    );
  };

  const CustomToolbar = ({ apiRef }) => {
    const selectedRows = apiRef.current.getSelectedRows();
    const selectedRowData = Array.from(selectedRows.values());

    const handleDeleteClick = () => {
      dispatch(actions.excluirCredencialRequest({ value: selectedRowData[0] }));
      setOpen(false);
    };

    const handleEdit = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        dispatch(
          routeActions.redirectTo(routes.CREDENCIAL, {
            idCredencial: selectedRowData[0].id
          })
        );
      }
    };

    return (
      <>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Confirmação para Exclusão de Credencial</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tem certeza de que deseja excluir a credencial {selectedRowData[0]?.descricao}? Ao excluir uma credencial,
              não será mais possível recuperar suas informações.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleDeleteClick} color="error">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport csvOptions={{ includeHeaders: true, allColumns: true }} />
          <Button
            variant="text"
            color="primary"
            onClick={handleNewCredential}
            startIcon={<AppstoreAddOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Incluir Credencial
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleEdit}
            startIcon={<EditOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Editar
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleClickOpen}
            startIcon={<DeleteOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px',
              color: `${selectedRows.size !== 1 ? theme.palette.grey.lighter : theme.palette.error.main} !important`
            }}
          >
            Excluir
          </Button>
        </GridToolbarContainer>
      </>
    );
  };

  return (
    <MainLayout>
      <MainCard title="Configuração de Credenciais de Integração" border={false} sx={{ paddingBottom: '0px' }}>
        <Box sx={{ marginTop: '5px' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[10]}
            getRowId={(row) => row.id}
            toolbar={CustomToolbar}
            loading={loading}
            pageSize={10}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              },
              density: 'standard'
            }}
          />
        </Box>
      </MainCard>
    </MainLayout>
  );
};

export default CredenciaisPage;
